import React from 'react';
import { Text } from '@chatsdet/ui';
type ConfigSectionProps = {
  title: string;
  count?: number;
  defaultExpanded?: boolean;
  children: React.ReactNode;
};

export const ConfigSection: React.FC<ConfigSectionProps> = ({
  title,
  count = 0,
  defaultExpanded,
  children,
}) => {
  const [isExpanded, setIsExpanded] = React.useState(defaultExpanded ?? count > 0);

  // Sync expansion when count transitions from 0 → positive (e.g. adding first item)
  const prevCountRef = React.useRef(count);
  React.useEffect(() => {
    if (prevCountRef.current === 0 && count > 0) {
      setIsExpanded(true);
    }
    prevCountRef.current = count;
  }, [count]);

  return (
    <div className="border-t border-border/40 py-3">
      <button
        type="button"
        className="flex items-center gap-1.5 w-full text-sm font-medium text-muted-foreground hover:text-foreground transition-colors text-left"
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <span className={`transition-transform text-xs ${isExpanded ? 'rotate-90' : ''}`}>
          ▶
        </span>
        {title}
        {count > 0 && (
          <Text size="xs" className="text-muted-foreground font-normal">
            ({count})
          </Text>
        )}
      </button>
      {isExpanded && <div className="mt-2">{children}</div>}
    </div>
  );
};
